import State from '../State';

export interface SetState {
	tag : 'SetState';
	val : null | State;
}

export const setState = ( val : null | State ) : SetState =>
	( { tag : 'SetState' , val } );

export const exeSetState = ( cmd : SetState ) : null | State => {
	return cmd.val;
};
